import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function ListPatientFoodStockCase(
  foodStockRepository: FoodStockRepository
) {
  return async function (patientId: string) {
    return await foodStockRepository.listPatientFoodStock(patientId)
  }
}
